module.exports = __webpack_public_path__ + "img/nav-design-diamondearrings.5f12d69.webp";